import { put, takeLatest } from 'redux-saga/effects';
import errorMessages from './errorMessages';
import { setNewError } from './duck';
import { DISPLAY_400_ERRORS_ACTIONS } from 'redux/modules/error-handler/constants';

// @effect Action
const newError$ = 'error-handler/newError$';

// @effect Creators
export const displayError = (error, action) => ({
  type: newError$,
  payload: {
    error,
    action: action,
  },
});

// Workers
export function* handleNewError({ payload }) {
  const { error, action } = payload;
  const { code } = error;

  try {
    if (code && errorMessages[code]) {
      // ignore 400 errors for some actions
      if (code === 400 && !DISPLAY_400_ERRORS_ACTIONS.includes(action)) {
        console.error(`Ignoring 400 error for action ${action}:`, error);
        return;
      }

      const actionDuringError = errorMessages[code][action] ? action : 'default';
      const errorMessage = errorMessages[code][actionDuringError];

      const { title, description } = errorMessage;
      yield put(setNewError(title, description));
    }
  } catch (err) {
    console.error('Error trying display a request error: ', err);
  }
}

// Watchers
export function* watchHandleErrors() {
  yield takeLatest(newError$, handleNewError);
}
